import React from 'react';
import DOMPurify from 'dompurify';
import linkifyHtml from 'linkify-html';

interface HtmlRendererProps {
  source: string;
  className?: string;
}

/**
 * Modifies all links to open in a new tab
 */
export const relinkLinksInNewTab = (source: string) => {
  const parsedHtml = new DOMParser().parseFromString(source, 'text/html');
  const aTags = parsedHtml.getElementsByTagName('a');

  for (let i = 0; i < aTags.length; i++) {
    aTags[i].setAttribute('target', '_blank');
    aTags[i].setAttribute('rel', 'noopener noreferrer');
  }

  const parsed = parsedHtml.documentElement.innerHTML;
  return parsed;
};

/**
 * Formats as links all valid URLs
 */
const linkUrls = (source: string) => {
  const parsed = linkifyHtml(source, {
    defaultProtocol: 'https',
    target: '_blank',
    rel: 'noopener noreferrer',
  });

  return parsed;
};

const sanitizeHtml = (source: string) => {
  const parsed = DOMPurify.sanitize(source, {
    USE_PROFILES: {
      html: true,
    },
    // allow html <a> tags to be allowed to be opened in a new tab
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ADD_ATTR: ['target', 'rel'],
  });

  return parsed;
};

const HtmlRenderer = ({ source, className }: HtmlRendererProps) => {
  const withRelinkedLinksInNewTab = relinkLinksInNewTab(source);
  const withLinkedUrls = linkUrls(withRelinkedLinksInNewTab);
  const withSanitizedHtml = sanitizeHtml(withLinkedUrls);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: withSanitizedHtml }}
    />
  );
};

export default HtmlRenderer;
